import { useCallback, useEffect, useMemo } from "react";
import { BaseFormControlledModal } from "../../../../../../common/components/base_form_controlled_modal";
import { DefaultFormSelectInput } from "../../../../../../common/components/default_form_select_input";
import { DefaultFormMultiAutocomplete } from "../../../../../../common/components/default_form_multi_autocomplete";
import { useForm } from "react-hook-form";
import { initialObraChecklistServico, ObraChecklistServicoForm, ObraChecklistServicoSchema } from "../../../schemas/Obras_checklistarea/obra_checklist_servico";
import { zodResolver } from "@hookform/resolvers/zod";
import { ChecklistServicoDropDown } from "../../../../domain/models/checklist_servico_dropdown";

import FormContainer from "../../../../../../common/components/form_container";

/**
 * ObraChecklistServicoModal
 */

type Props = {
  open: boolean;
  saving: boolean;
  loading: boolean;
  checklistServicos: ChecklistServicoDropDown[];
  onSelectTipoServico: (tipoServico: number) => void;
  onClose: () => void;
  onSubmit: (form: any) => void;
};

export const ObraChecklistServicoModal = ({
  open,
  saving,
  loading,
  checklistServicos,
  onSelectTipoServico,
  onClose,
  onSubmit,
}: Props) => {
  const hookForm = useForm<ObraChecklistServicoForm>({
    mode: 'onSubmit',
    reValidateMode: 'onSubmit',
    defaultValues: initialObraChecklistServico,
    resolver: zodResolver(ObraChecklistServicoSchema),
  });

  const [selectedTipoServico] = hookForm.watch(['tipoServico']);

  const tipoServico = useMemo(() => {
    return [
      { id: 2, label: 'Todos os Checklist\'s' },
      { id: 0, label: 'Controlado' },
      { id: 1, label: 'Especializado' },
    ];
  }, [
  ]);

  useEffect(() => {
    hookForm.reset(initialObraChecklistServico);
  }, [
    open,
    hookForm,
  ]);

  useEffect(() => {
    onSelectTipoServico(selectedTipoServico);
    hookForm.resetField('checklistServicos');
  }, [
    hookForm,
    selectedTipoServico,
    onSelectTipoServico,
  ]);

  const handleClose = useCallback(() => {
    if (!saving && !loading) {
      onClose();
    }
  }, [
    saving,
    loading,
    onClose,
  ]);

  const handleSubmit = useCallback((e: any) => {
    if (!saving && !loading) {
      onSubmit(e);
    }
  }, [
    saving,
    loading,
    onSubmit,
  ]);

  return (
    <BaseFormControlledModal
      open={open}
      saving={saving}
      loading={loading}
      title='Checklist de serviço'
      width="50rem"
      onClose={handleClose}
      onSubmit={hookForm.handleSubmit(handleSubmit)}>
      <FormContainer title="Informações" arrangement="fullRow">
        <>
          <DefaultFormSelectInput
            name='tipoServico'
            label='Tipo de Serviço'
            options={tipoServico}
            required={true}
            showSelectionLabel={false}
            reactHookForm={hookForm}
          />

          <DefaultFormMultiAutocomplete
            name='checklistServicos'
            label='Selecione o Checklist de Serviço'
            options={checklistServicos}
            getOptionKey={x => x.idChecklistServico}
            getOptionLabel={x => x.descricao}
            required={true}
            reactHookForm={hookForm}
          />
        </>
      </FormContainer>
    </BaseFormControlledModal>
  );
}